import React from 'react';
import { useTheme } from 'styled-components';
import { ButtonWrapper, ContentText, HiddenTextContainer, ShowedTextContainer, TooltipContainer } from './styles';
import { ButtonTypes } from '../../../types';
import Tooltip from '../Tooltip';
import { IMainTheme } from '../../../types/theme';
import { IAdobeClickEvent } from '../../../types/tracking';

export interface IRedirection {
  type: 'category' | 'product' | 'custom' | 'page' | 'any';
  value: string;
}

export interface IButtonProps {
  type?: ButtonTypes;
  children: React.ReactNode;
  Tag?: any;
  handleClick?: (e: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  classNames?: string[];
  handleOver?: (e: React.MouseEvent<HTMLElement>) => void;
  handleLeave?: (e: React.MouseEvent<HTMLElement>) => void;
  tooltipContent?: string | boolean;
  subscriptionId?: string;
  tooltipTracking?: IAdobeClickEvent;
  tooltipTrackingType?: string;
}

const Button = ({
  Tag = 'a',
  children,
  disabled = false,
  type = 'default',
  handleClick,
  handleOver,
  handleLeave,
  classNames,
  tooltipContent,
  subscriptionId,
  tooltipTracking,
  tooltipTrackingType = 'clickevent',
}: IButtonProps) => {
  const theme = useTheme() as IMainTheme;
  return (
    <ButtonWrapper
      data-subscriptionid={subscriptionId}
      as={Tag}
      type={type}
      onClick={!disabled ? handleClick : () => false}
      disabled={disabled}
      onMouseOver={handleOver}
      onMouseOut={handleLeave}
      tabIndex="0"
      className={classNames}
    >
      <ContentText withTooltip={!!tooltipContent}>
        <HiddenTextContainer aria-hidden>{children}</HiddenTextContainer>
        <ShowedTextContainer>{children}</ShowedTextContainer>
      </ContentText>
      {tooltipContent ? (
        <TooltipContainer>
          <Tooltip
            backgroundColor={theme.colors['SilverChalice']}
            tracking={tooltipTracking}
            trackingType={tooltipTrackingType}
          >
            {tooltipContent}
          </Tooltip>
        </TooltipContainer>
      ) : null}
    </ButtonWrapper>
  );
};

export default Button;
